<template>
  <onboarding
    :cta="$store.getters['brand/showStore'] && $t('_action.place_new_order')"
    :subtitle="$t('_sentence.no_products_or_services_msg')"
    :title="$t('_.no_products_or_services')"
    img="/assets/images/interface/icons/014-flyers.svg"
    :no-card="noCard"
    @click="$router.push({ name: `order` })"
  />
</template>

<script>
export default {
  name: "NoProductsOnboarding",
  props: {
    noCard: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
